module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 16 30",
      url: __webpack_public_path__ + "img/icons.400d09d6.svg#facebook-usage",
      toString: function () {
        return this.url;
      }
    }